import React from 'react'
import { interpolate } from '../utils/proposalVariables'
import { calculateMonthlyPrice, isAsNeeded } from '../utils/frequencyConfig'

const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount || 0)
}

// Backward-compat: use perVisitPrice if present, fall back to monthlyPrice
const getMonthlyPrice = (svc) => {
  if (svc.perVisitPrice != null && svc.perVisitPrice !== '') {
    return calculateMonthlyPrice(svc.perVisitPrice, svc.frequency)
  }
  return Number(svc.monthlyPrice) || 0
}

const ProjectDetails = ({ data, crmSnapshot, scopeData, variables }) => {
  const details = (data?.details || []).filter(d => d.label || d.value)

  // Calculate total from scope services, excluding as-needed
  const visibleServices = (scopeData?.services || []).filter(s => !s.hidden)
  const monthlyTotal = visibleServices.reduce((sum, svc) => {
    if (isAsNeeded(svc.frequency)) return sum
    return sum + getMonthlyPrice(svc)
  }, 0)

  return (
    <div className="proposal-section">
      <div className="proposal-section__headline">{data?.headline || 'Project Details'}</div>
      <div className="proposal-section__accent-line" />

      {details.length > 0 && (
        <div className="proposal-project__list">
          {details.map((item, idx) => (
            <div className="proposal-project__item" key={idx}>
              <div className="proposal-project__item-label">{item.label}</div>
              <div className="proposal-project__item-value">{item.value || '\u2014'}</div>
            </div>
          ))}
        </div>
      )}

      {data?.additionalNotes && (
        <div className="proposal-project__notes">{interpolate(data.additionalNotes, variables)}</div>
      )}

      {/* Total Price Callout */}
      {monthlyTotal > 0 && (
        <div className="proposal-project__total">
          <div className="proposal-project__total-label">
            {scopeData?.annualTotalLabel || 'Total Monthly Maintenance Fee'}
          </div>
          <div className="proposal-project__total-amount">
            {formatCurrency(monthlyTotal)}
          </div>
          {/* <div className="proposal-project__total-note">
            (includes weekly labor, irrigation tech, dump fee)
          </div> */}
        </div>
      )}

      {/* Signature Block */}
      <div className="proposal-signature">
        <div className="proposal-signature__row">
          <div className="proposal-signature__field">
            <div className="proposal-signature__line" />
            <div className="proposal-signature__label">Accepted</div>
          </div>
          <div className="proposal-signature__field">
            <div className="proposal-signature__line" />
            <div className="proposal-signature__label">Date</div>
          </div>
        </div>
        {/* <div className="proposal-signature__closing">
          {data?.signatureClosing || 'Sincerely,'}{' '}
          {data?.signatureName || crmSnapshot?.yourName || ''}
        </div> */}
      </div>
    </div>
  )
}

export default ProjectDetails
